import { Icon } from '@design';
import clsx from 'clsx';
import React, { InputHTMLAttributes } from 'react';

import styles from './SearchInput.module.scss';

export interface SearchInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  onClear(): void;
  showClearButton?: boolean;
}

export const SearchInput = ({
  onClear,
  showClearButton = false,
  ref,
  className,
  ...rest
}: SearchInputProps & { ref?: React.Ref<HTMLInputElement> }) => {
  return (
    <div className={clsx(styles.searchInputRoot, className)}>
      <div className={styles.inputContainer}>
        <div className={styles.searchIcon}>
          <Icon iconName="Search" size={24} />
        </div>

        <input
          ref={ref}
          className={styles.input}
          data-testid="search-input"
          type="text"
          autoComplete="off"
          spellCheck={false}
          {...rest}
        />

        {showClearButton && (
          <button
            className={styles.clearButton}
            type="button"
            data-testid="clear-button"
            onClick={onClear}
          >
            <Icon iconName="CloseFillCircle" size={20} />
          </button>
        )}
      </div>
    </div>
  );
};
